module.exports = __webpack_public_path__ + "img/2.c86889a1.png";